import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "intelligence-infinityai",
  "use": "intelligence-infinityai-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 60\" id=\"intelligence-infinityai\"><g clip-path=\"url(#intelligence-infinityai_clip0_2341_11507)\" stroke=\"currentColor\" stroke-width=\"2\"><path d=\"M30 29s-3.429-7-9-7a7.001 7.001 0 000 14c2.68 0 5.071-1.634 6.714-3.5M30 29s3.429 7 9 7a7.001 7.001 0 000-14c-2.68 0-5.071 1.634-6.714 3.5\" stroke-linecap=\"round\" /><path clip-rule=\"evenodd\" d=\"M14.555 5.615a3.117 3.117 0 012.7-1.559h25.33a3.115 3.115 0 012.698 1.559L57.948 27.55a3.114 3.114 0 010 3.116L45.283 52.603a3.114 3.114 0 01-2.699 1.559h-25.33a3.117 3.117 0 01-2.699-1.559L1.891 30.667a3.117 3.117 0 010-3.116L14.555 5.615z\" /></g><defs><clipPath id=\"intelligence-infinityai_clip0_2341_11507\"><path fill=\"currentColor\" d=\"M0 0h60v60H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/intelligence-infinityai.svg
// module id = jtvX
// module chunks = 39 44